import { IconButton, Tooltip } from "@mui/material";
import { useBoardContext } from "@rastreabilidadebrasil/tageditor";
import { Cursor, ArrowsMove, BorderCenter, Plus, Dash } from "react-bootstrap-icons";
import { Divider } from "@mui/material";
const step = 0.2;

function ZoomStatus() {
  const { boardZoom, boardDragMode, board } = useBoardContext();

  const fitToCenter = () => {
    if (board) {
      const workspace = board.getWorkspace();
      board.fitTo(workspace);
    }
  };

  const zoomOut = () => boardZoom?.set(round(boardZoom?.value - step));

  const lowestValue = () => boardZoom?.value === boardZoom?.min;

  const zoomIn = () => boardZoom?.set(round(boardZoom?.value + step));

  const highestValue = () => boardZoom?.value === boardZoom?.max;

  const round = (value: number) => {
    return Math.round((value + Number.EPSILON) * 100) / 100;
  };

  return (
    <div className="statusbar-container drag-container">
      <span className="statusbar-zoom">
        {((boardZoom?.value || 1) * 100).toFixed(0)}%
        <div className="statusbar-zoom-buttons">
          <IconButton onClick={zoomIn} disabled={highestValue()}>
            <Plus size={10} />
          </IconButton>

          <IconButton onClick={zoomOut} disabled={lowestValue()}>
            <Dash size={10} />
          </IconButton>
        </div>
      </span>

      <Divider orientation="vertical" flexItem={true} />

      <Tooltip title={"Centralizar na tela"}>
        <IconButton onClick={fitToCenter} size="large" className={`cursor-button`}>
          <BorderCenter />
        </IconButton>
      </Tooltip>

      <Divider orientation="vertical" flexItem={true} />

      <Tooltip title={"Mover etiqueta"}>
        <IconButton
          onClick={() => {
            if (boardDragMode) {
              boardDragMode.mode = "grab";
            }
          }}
          size="large"
          className={`cursor-button ${boardDragMode?.mode === "grab" ? "active" : ""}`}
        >
          <ArrowsMove />
        </IconButton>
      </Tooltip>

      <Tooltip title="Selecionar elementos">
        <IconButton
          onClick={() => {
            if (boardDragMode) {
              boardDragMode.mode = "selection";
            }
          }}
          size="large"
          className={`cursor-button ${boardDragMode?.mode === "selection" ? "active" : ""}`}
        >
          <Cursor />
        </IconButton>
      </Tooltip>
    </div>
  );
}

export default ZoomStatus;
